var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary fab align-items-center d-flex justify-content-center",on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"fas fa-plus text-white"})])}
var staticRenderFns = []

export { render, staticRenderFns }